/* ==========================================================================
   eg-lymph-reasons — the reasons rail.

   The rail is a native scroll-snap strip, so swiping works on its own. A stop
   is every scroll position a card can snap to before the rail runs out, so on
   desktop (three cards in view) five cards make three stops and on mobile
   five. The arrows step between stops and fade at either end; the dots are
   drawn from the stops and follow the scroll.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.lfwInit === 'true') return;
    root.dataset.lfwInit = 'true';

    var rail = root.querySelector('[data-lfw-rail]');
    var prev = root.querySelector('[data-lfw-prev]');
    var next = root.querySelector('[data-lfw-next]');
    var dotsBox = root.querySelector('[data-lfw-dots]');
    if (!rail) return;

    var cards = Array.prototype.slice.call(rail.querySelectorAll('[data-lfw-card]'));
    var stops = [];
    var dots = [];

    function measure() {
      var pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
      var max = rail.scrollWidth - rail.clientWidth;
      stops = [];
      cards.forEach(function (card) {
        var at = Math.min(Math.max(card.offsetLeft - pad, 0), max);
        if (!stops.length || at - stops[stops.length - 1] > 2) stops.push(at);
      });
      drawDots();
      update();
    }

    function drawDots() {
      if (!dotsBox) return;
      dotsBox.innerHTML = '';
      dots = stops.map(function (at, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'lfw__dot';
        dot.setAttribute('aria-label', 'Go to reason ' + (i + 1));
        dot.addEventListener('click', function () {
          rail.scrollTo({ left: at, behavior: 'smooth' });
        });
        dotsBox.appendChild(dot);
        return dot;
      });
      dotsBox.hidden = stops.length < 2;
    }

    function current() {
      var x = rail.scrollLeft;
      var best = 0;
      stops.forEach(function (at, i) {
        if (Math.abs(at - x) < Math.abs(stops[best] - x)) best = i;
      });
      return best;
    }

    function update() {
      var i = current();
      dots.forEach(function (dot, n) {
        dot.classList.toggle('is-active', n === i);
        dot.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= stops.length - 1;
    }

    function step(dir) {
      var i = Math.min(Math.max(current() + dir, 0), stops.length - 1);
      rail.scrollTo({ left: stops[i], behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measure, 150);
    });

    measure();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lfw]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
